import s from './styles.scss';

export const BypassBlock = () => (
  <a className={s.bypassBlock} href="#main-content">
    <span>Skip to main content</span>
  </a>
);
